<div *ngIf="this.interactive && !this.loggedIn" id="login-form-div">
    <div class="text-center"><h3 *ngIf="!this.qrCodeUsed else welcome">Second view candidate access</h3></div>
    <div class="note text-danger"><b>Note:</b> You are advised to place your mobile device in <b>Do Not Disturb</b> mode to prevent disconnection. Also ensure that the device is plugged in or you have sufficient charge to last the duration of the exam/test</div>
    <form #login="ngForm" name="login" (ngSubmit)="this.loginClicked()"  style="border: 0px !important;"
    class="login-form" [attr.aria-labelledby]="'loginTitle'">
        <div *ngIf="!externaltoken">
            <div [hidden]="this.qrCodeUsed" class="form-group">
                <label class="form-control-label" for="candidate-number">Candidate Number</label>
                <input [disabled]="this.loggingIn || this.qrCodeUsed" class="form-control" placeholder="" type="text" required name="candidate-number"
                [(ngModel)]="this.secondViewCandidateNumber" id="candidate-number">
            </div>
            <div [hidden]="this.qrCodeUsed" class="form-group">
                <label class="form-control-label" for="access-code">Access Code</label>
                <input [disabled]="this.loggingIn || this.qrCodeUsed" class="form-control" placeholder="" required type="text" name="access-code"
                    [(ngModel)]="this.secondViewAccessCode"  id="access-code" autofocus>
            </div>
            <div class="text-center">
                <label class="form-control-label" for="instructions-checkbox">I have read ALL instructions and I am ready to proceed</label>
                <input class="ml-2" type="checkbox" required name="instructions-checkbox" id="instructions-checkbox" [(ngModel)]="this.instructionsCheckboxChecked" />
            </div>
            <div class="text-center">
                <button *ngIf="!this.loggingIn else loginSpinnerDiv" type="submit" class="btn btn-primary my-4 form-control"
                    [disabled]="login.invalid || !this.instructionsCheckboxChecked || this.loggingIn" attr.aria-label="Submit Login Form">
                    <span>Continue</span>
                </button>
            </div>
        </div>
    </form>
</div>

<div [hidden]="!this.loggedIn || this.examHasEnded" id="camera-display-div">
    <div id="camera-display-video-div">
        <video disablePictureInPicture #secondVideo autoplay playsinline muted id="video"></video>
    </div>
    <div class="text-center pl-1 pr-1 pb-1" id="camera-display-instructions-div">
        <div *ngIf="!this.connected && !this.connecting else proceedMessageDiv"><b>Follow the instructions and place the device at the appropriate angle. Tap "Connect" when ready</b></div>
        <div class="connect-btn-div">
            <button *ngIf="!this.connected && !this.connecting" class="btn btn-primary" [disabled]="this.connecting" (click)="this.connectClicked()"><span>Connect</span></button>
            <ng-container *ngIf="this.connecting then spinner"></ng-container>
        </div>
        <ng-template #proceedMessageDiv><ng-container *ngIf="this.connected"><b>You are connected. <b class="text-danger">Do not close this page until your exam is over.</b> Please proceed on your computer</b></ng-container></ng-template>
    </div>
</div>

<div *ngIf="this.interactive && this.examHasEnded" id="exam-ended-div">
    <div>The exam/test has ended. You may now close your browser</div>
</div>

<ng-template #spinner>
    <app-loading-spinner [height]="40" [color]="'#3472c5'"></app-loading-spinner>
</ng-template>

<ng-template #loginSpinnerDiv>
    <div class="my-4">
        <ng-container *ngIf="true then spinner"></ng-container>
    </div>
</ng-template>

<ng-template #welcome>
    <h3>Welcome, <b>{{this.secondViewCandidateNumber}}</b></h3>
</ng-template>
